import { Children, cloneElement, isValidElement, useEffect, useState } from "react";
import { TablePagination } from "./TablePagination";

/** Paginate complete, locally available row collections. Server-paged tables use TablePagination directly. */
export function ClientTable({ children, pageSize = 10, ...props }) {
  const [page, setPage] = useState(1);
  const sections = Children.toArray(children);
  const body = sections.find(section => isValidElement(section) && section.type === "tbody");
  const rows = Children.toArray(body?.props.children).filter(isValidElement);
  const size = Math.max(1, Number(pageSize) || 10);
  // Empty/loading placeholders span the table and are not data records.
  const placeholder = rows.length === 1 && rows[0].type === "tr" &&
    Children.toArray(rows[0].props.children).some(cell => Number(cell.props?.colSpan) > 1);
  const total = placeholder ? 0 : rows.length;
  const pages = Math.max(1, Math.ceil(total / size));
  const current = Math.min(page, pages);
  const rowKeys = rows.map(row => row.key).join("|");
  useEffect(() => { setPage(1); }, [rowKeys, size]);
  const visibleRows = placeholder ? rows : rows.slice((current - 1) * size, current * size);
  return <>
    <table {...props}>
      {sections.map(section => section === body ? cloneElement(section, {}, visibleRows) : section)}
    </table>
    {body && <TablePagination page={current} totalPages={pages} totalItems={total} pageSize={size} onPageChange={setPage} />}
  </>;
}
